module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-Bold.0c44101d.otf";